import * as NotificationAPIUtil from '../../util/notification_util';
export const RECEIVE_NOTIFICATIONS = 'RECEIVE_NOTIFICATIONS';
export const RECEIVE_NOTIFICATION = 'RECEIVE_NOTIFICATION';
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';

export const receiveNotifications = notifications => {
  return {
    type: RECEIVE_NOTIFICATIONS,
    notifications
  }
};

export const receiveNotification = notification => {
  return {
    type: RECEIVE_NOTIFICATION,
    notification
  }
};

export const fetchNotifications = (fetchUnread) => dispatch => (
  NotificationAPIUtil.fetchAllNotifications(fetchUnread)
    .then(notifications => {
      dispatch(receiveNotifications(notifications));
      return notifications; // Ensure the data is returned
    })
    .catch(err => console.log(err))
);

export const createNotification = notification => dispatch => (
  NotificationAPIUtil.createNotification(notification).then(notification => (
    dispatch(receiveNotification(notification.data))
  ))
);

export const updateNotificationRead = () => dispatch => (
  NotificationAPIUtil.updateNotificationRead()
    .then(notifications => dispatch(receiveNotifications(notifications.data)))
    .catch(err => console.log(err))
);
